var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page"}},[_c('BioDataNav',{attrs:{"vsteps":_vm.vsteps}}),_c('section',{staticClass:"w-full",attrs:{"id":"holder"}},[_c('div',{staticClass:"w-12/12 lg:11/12"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }